module.exports = __webpack_public_path__ + "static/media/car-mini-minibus-svgrepo-com-city-comm.7d1ba625.svg";